/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getActualUseList = (payload, callback) =>
  req.list(
    c.GET_ACTUAL_USES,
    'api/v1/rpt/administrator/settings/actual_uses',
    payload,
    callback
  );

export const getSingleActualUse = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_ACTUAL_USE,
    `api/v1/rpt/administrator/settings/actual_uses/${id}`,
    payload,
    callback
  );

export const createActualUse = (payload, callback) =>
  req.create(
    c.CREATE_ACTUAL_USE,
    'api/v1/rpt/administrator/settings/actual_uses',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateActualUse = (id, payload, callback) =>
  req.update(
    c.UPDATE_ACTUAL_USE,
    `api/v1/rpt/administrator/settings/actual_uses/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeActualUse = (id, payload, callback) =>
  req.remove(
    c.REMOVE_ACTUAL_USE,
    `api/v1/rpt/administrator/settings/actual_uses/${id}`,
    payload,
    res => {
      const { message } = res.res;
      alert.success(message || 'Successfully Removed !');
      if (callback) callback();
    }
  );

export const getLandClassificationsList = (payload, callback) =>
  req.list(
    c.GET_LAND_CLASSIFICATION_LIST,
    'api/v1/rpt/administrator/land/settings/land_classifications',
    payload,
    callback
  );